
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkBudgetAccount } from '../models/work-budget-account';
import { WorkBusinessdivision } from '../models/work-businessdivision';
import { WorkBusinessunit } from '../models/work-businessunit';

export function getBudgetEntryFormGroup() {
return new FormGroup({
    id: new FormControl<number | undefined>(undefined, [Validators.required]),
    created: new FormControl<string | undefined>(undefined),
    modified: new FormControl<string | undefined>(undefined),
    budgetAccountId: new FormControl<number | undefined>(undefined, [Validators.required]),
    budgetAccount: new FormControl<WorkBudgetAccount | undefined>(undefined),
    businessdivisionId: new FormControl<number | undefined>(undefined, [Validators.required]),
    businessdivision: new FormControl<WorkBusinessdivision | undefined>(undefined),
    businessunitId: new FormControl<number | undefined>(undefined, [Validators.required]),
    businessunit: new FormControl<WorkBusinessunit | undefined>(undefined),
    year: new FormControl<number | undefined>(undefined, [Validators.required]),
    month: new FormControl<number | undefined>(undefined, [Validators.required]),
    sollValue: new FormControl<number | undefined>(undefined, [Validators.required]),
    istValue: new FormControl<number | undefined>(undefined, [Validators.required]),
    createdBy: new FormControl<number | undefined>(undefined),
    modifiedBy: new FormControl<number | undefined>(undefined),
})
;
}
      